import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

function UserTimerInfo() {
  return (
    <div className="bg-[#E3EBFF] min-h-[31px] flex items-center pl-2 pr-2 rounded-md  text-black">
      <InformationCircleIcon className="h-5 w-5 mr-1" />
      <p
        className="text-[12px] italic flex items-center"
        style={{ fontFamily: "gilRoy-semibold" }}
      >
        Note: All amounts will be updated every 15 minutes. This means that if
        any transaction takes place now, you will need to wait for the next 15
        minutes for it to be reflected on the screen.
      </p>
    </div>
  );
}

export default UserTimerInfo;
